import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { COMMENT_DELETE } from '../queries';
import { useMutation } from './base';
export const useCommentDeleteMutation = (endpoint, queryKey) => {
    const client = useQueryClient();
    return useMutation(COMMENT_DELETE, endpoint, {
        onSuccess: (data) => {
            const comment = data;
            client.setQueryData(queryKey, (old) => {
                const defaultVal = {
                    pageParams: [],
                    pages: [],
                };
                const updated = produce(old || defaultVal, (draft) => {
                    if (draft.pages.length) {
                        let isFound = false;
                        for (let page of draft.pages) {
                            if (isFound)
                                break;
                            for (let idx = 0; idx < page.comments.length; idx++) {
                                if (page.comments[idx].id === data.id) {
                                    page.comments.splice(idx, 1);
                                    isFound = true;
                                    break;
                                }
                            }
                        }
                    }
                });
                return updated;
            });
        },
    }, (data) => data.comment);
};
//# sourceMappingURL=useCommentDeleteMutation.js.map